var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIconTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23121 21.846C3.37121 24.2494 4.66621 26.221 7.88621 26.221H20.1129C23.3329 26.221 24.6162 24.2494 24.7679 21.846L25.3745 12.2094C25.5379 9.68936 23.5312 7.55436 20.9995 7.55436C20.2879 7.55436 19.6345 7.14603 19.3079 6.51603L18.4679 4.82436C17.9312 3.7627 16.5312 2.8877 15.3412 2.8877H12.6695C11.4679 2.8877 10.0679 3.7627 9.53121 4.82436L8.69121 6.51603C8.36454 7.14603 7.71121 7.55436 6.99954 7.55436C4.46788 7.55436 2.46121 9.68936 2.62454 12.2094L2.92788 16.9577",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 9.8877H15.75",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 21.554C16.089 21.554 17.7923 19.8507 17.7923 17.7624C17.7923 15.674 16.089 13.9707 14.0007 13.9707C11.9123 13.9707 10.209 15.674 10.209 17.7624C10.209 19.8507 11.9123 21.554 14.0007 21.554Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIconTransparent);
export default __webpack_public_path__ + "static/media/cameraIconTransparent.4282bcc4138c7a4480b11603eb5f59a9.svg";
export { ForwardRef as ReactComponent };